import Vue from 'vue'
import Vuex from 'vuex'
import error from './modules/error'
import auth from './modules/auth'
import notification from './modules/notification'
import userNotifications from './modules/user-notifications'
import featureToggle from './modules/feature-toggle'
import dashboard from './modules/dashboard'
import builder from './modules/builder'
import modals from './modules/modals'
import datahubEvents from './modules/datahubEvents'
import gtag from './modules/gtag'

Vue.use(Vuex)

const debug = process.env.DEBUG === 'true' || process.env.NODE_ENV !== 'production'

const storeManager = new Vuex.Store({
  strict: debug,
  modules: {
    error,
    auth,
    notification,
    userNotifications,
    featureToggle,
    dashboard,
    builder,
    datahubEvents,
    modals,
    gtag
  }
})

export default storeManager
